import { II9FormViewerRepository } from "../ports/II9FormViewerRepository";

export class FetchBase64ImageUseCase {
    constructor(private readonly repository: II9FormViewerRepository) { }

    async execute(documentUrl: string): Promise<string> {
        return this.repository.getBase64Document(documentUrl);
    }
}